<template>
  <div class="container">
    <div class="dateRangeContainer flex flex-between">
      <div class="dateTypeContainer">
        <div class="flex flex-evenly">
          <van-col
            span="8"
            :class="channelType === 0 ? 'active item' : 'item'"
            @click="changeChannelType(0)"
            >全部</van-col
          >
          <van-col
            span="8"
            :class="channelType === 1 ? 'active item' : 'item'"
            @click="changeChannelType(1)"
            >零售</van-col
          >
          <van-col
            span="8"
            :class="channelType === 2 ? 'active item' : 'item'"
            @click="changeChannelType(2)"
            >新零售</van-col
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      channelType: 0,
    };
  },
  props: {
    title: String,
  },
  computed: {
    getChannelText() {
      const channelMap = ["全部", "零售", "新零售"];
      return channelMap[this.channelType];
    },
  },
  methods: {
    handleEmit() {
      this.$emit("change", this.channelType, this.getChannelText);
    },
    changeChannelType(index) {
      this.channelType = index;
      this.$nextTick(() => {
        this.handleEmit();
      });
    },
  },
};
</script>

<style scoped lang="less">
.container {
  background-color: transparent;
}
.dateRangeContainer {
  padding: 10px 0;
}
.dateTypeContainer {
  background-color: rgba(130, 183, 157, 1);
  padding: 5px 0;
  border-radius: 15px;
  width: 9rem;

  .item {
    font-size: 0.8rem;
    width: 3rem;
    height: 26px;
    text-align: center;
    line-height: 25px;
    border-radius: 20px;
    color: #fff;
  }
  .active.item {
    background-color: #ffffff;
    color: #4c9673;
  }
}
.bg2 {
  background-color: #3c8260;
}
</style>
